import { STEP_IDENTIFIER_NAME } from '../constants';
import type { StepConfig } from '../types';

const { DESCRIPTION } = STEP_IDENTIFIER_NAME;

export const description: StepConfig = {
	name: DESCRIPTION,
	isAuthenticationRequired: false,
	isEnabled: () => true,
};
